import React, { useState, useEffect, useCallback, forwardRef } from "react";
import { TextField, InputLabel, Select, MenuItem, FormControl, Input, FormHelperText } from "@mui/material";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import _ from "lodash";
import { Utils } from "common/Utils";

const viewDataOnly = false
const EmployeeEmployment = forwardRef(({ fetchedData, employmentStatus, employeeGroups,errors }, ref) => {
  console.log('ee employment')
  console.dir(fetchedData)
  const [formData, setFormData] = useState(fetchedData);

  const handleChange = _.debounce((name, val) => {
    console.log(val, 'handle change value')
    console.log(formData, 'handle change formData')
    
    let updatedValue = { [name]: val };
    setFormData(formData => ({
      ...formData,
      ...updatedValue
    }));
    if (ref?.current) {
      console.log('setting current')
      ref.current.formData = {
        ...formData,
        ...updatedValue
      };
      console.log(ref.current.formData, ' set ref current formData')
    }
    if(name=='employeeGroupID'){
      let empGrp = employeeGroups.find(eg=>eg.employeeGroupId==val);
      if(empGrp!=null){
        handleChange('benefitPackageID',empGrp.benefitPackageId)
      }
    }
  }, 500);

  return (
    <>
      <FormControl 
        className={ModalStyles.cField} >
        <InputLabel shrink>Effective Change Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
        defaultValue={
          (formData.effectiveDateOfChange === null) && viewDataOnly
            ? ""
            : Utils.convertToDatePickerDefaultToday(formData.effectiveDateOfChange)
        }
        onChange={e => handleChange('effectiveDateOfChange', e.target.value)}
        />
      </FormControl>
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Alternate Key"
        defaultValue={
          formData.employeeAltKey === null && viewDataOnly
            ? "N/A"
            : formData.employeeAltKey
        }
        onChange={e => handleChange('employeeAltKey', e.target.value)}
      />
      <FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}
        error={errors.employeeGroupID ? true : false}>
        <InputLabel >Employee Group</InputLabel>
        <Select
          id="employeeGroupID"
          name="employeeGroupID"
          label="Employee Group"
          value={formData.employeeGroupID || ''}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('employeeGroupID', e.target.value)}
        >
          {employeeGroups.map((val, i) => <MenuItem value={val.employeeGroupId} key={i}>{val.employeeGroupName}</MenuItem>)}

        </Select>
        <FormHelperText id="component-error-text">{errors.employeeGroupID}</FormHelperText>
      </FormControl>
      <FormControl 
        className={ModalStyles.cField} 
        error={errors.hireDate ? true : false}>
        <InputLabel shrink>Hire Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
        defaultValue={
          (formData.hireDate === null) && viewDataOnly
            ? ""
            : Utils.convertToDatePicker(formData.hireDate)
        }
        onChange={e => handleChange('hireDate', e.target.value)}
        />
        <FormHelperText id="component-error-text">{errors.hireDate}</FormHelperText>
      </FormControl>

      <FormControl sx={{ m: 1, minWidth: 150 }}
        className={ModalStyles.cField}
        error={errors.employmentStatusID ? true : false}>
        <InputLabel >Employment Status</InputLabel>
        <Select
          id="employmentStatusID"
          name="employmentStatusID"
          label="Employment Status"
          value={formData.employmentStatusID || ''}
          required
          shrink
          size="small"
          variant="standard"
          onChange={e => handleChange('employmentStatusID', e.target.value)}
        >
          {employmentStatus.map((val, i) => <MenuItem value={val.employmentStatusId} key={i}>{val.employmentStatusName}</MenuItem>)}

        </Select>
        <FormHelperText id="component-error-text">{errors.employmentStatusID}</FormHelperText>
      </FormControl>

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Hourly Salary"
        defaultValue={
          formData.hourlySalary === null && viewDataOnly
            ? "N/A"
            : formData.hourlySalary
        }
        onChange={e => handleChange('hourlySalary', e.target.value)}
        error={errors.hourlySalary ? true : false}
        helperText={errors.hourlySalary}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Weekly Salary"
        defaultValue={
          formData.weeklySalary === null && viewDataOnly
            ? "N/A"
            : formData.weeklySalary
        }
        onChange={e => handleChange('weeklySalary', e.target.value)}
        error={errors.weeklySalary ? true : false}
        helperText={errors.weeklySalary}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Annual Salary"
        defaultValue={
          formData.annualSalary === null && viewDataOnly
            ? "N/A"
            : formData.annualSalary
        }
        onChange={e => handleChange('annualSalary', e.target.value)}
        error={errors.annualSalary ? true : false}
        helperText={errors.annualSalary}
      />

      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Job Title"
        defaultValue={
          formData.jobTitle === null && viewDataOnly
            ? "N/A"
            : formData.jobTitle
        }
        onChange={e => handleChange('jobTitle', e.target.value)}
      />
      <TextField
        variant="standard"
        InputProps={{
          readOnly: viewDataOnly,
        }}
        className={ModalStyles.cField}
        label="Location Code"
        defaultValue={
          formData.locationCode === null && viewDataOnly
            ? "N/A"
            : formData.locationCode
        }
        onChange={e => handleChange('locationCode', e.target.value)}
      />
      
      <FormControl 
        className={ModalStyles.cField} >
        <InputLabel shrink>Rehire Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
        defaultValue={
          (formData.rehireDate === null) && viewDataOnly
            ? ""
            : Utils.convertToDatePicker(formData.rehireDate)
        }
        onChange={e => handleChange('rehireDate', e.target.value)}
        />
      </FormControl>

      <FormControl 
        className={ModalStyles.cField} >
        <InputLabel shrink>Service Credit Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
        defaultValue={
          (formData.serviceCreditDate === null) && viewDataOnly
            ? ""
            : Utils.convertToDatePicker(formData.serviceCreditDate)
        }
        onChange={e => handleChange('serviceCreditDate', e.target.value)}
        />
      </FormControl>
      

      <FormControl 
        className={ModalStyles.cField} >
        <InputLabel shrink>Term Date</InputLabel>
        <Input id="my-input" aria-describedby="my-helper-text" type="date"
        defaultValue={
          (formData.termDate === null) && viewDataOnly
            ? ""
            : Utils.convertToDatePicker(formData.termDate)
        }
        onChange={e => handleChange('termDate', e.target.value)}
        />
      </FormControl>
      
    </>
  )
});

export default EmployeeEmployment;